export default __webpack_public_path__ + "static/media/99startup_icon.f0c31a83.jpg";